// extracted by mini-css-extract-plugin
export default {"Team":"TeamDark_Team__5SsyM","btnDiv":"TeamDark_btnDiv__ctiHF","alumniBtn":"TeamDark_alumniBtn__RS6zI"};